import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChristmas = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.452 3.5a.96.96 0 0 0-.958.959v.059a.75.75 0 0 1-.478.699 8.5 8.5 0 0 1 2.874 0 .75.75 0 0 1-.479-.7V4.46a.964.964 0 0 0-.959-.959m-1.708 1.768A8.47 8.47 0 0 0 4.76 10.04a1 1 0 0 0-.055.122A8.4 8.4 0 0 0 4 13.548 8.45 8.45 0 0 0 12.452 22c3.922 0 7.223-2.675 8.176-6.3l.006-.024c.177-.68.27-1.393.27-2.128a8.4 8.4 0 0 0-.49-2.842 8.47 8.47 0 0 0-6.255-5.438h.002a.75.75 0 0 0 .75-.75v-.06A2.464 2.464 0 0 0 12.452 2a2.46 2.46 0 0 0-2.458 2.459v.059c0 .414.335.75.75.75M5.969 11.03a6.94 6.94 0 0 0-.44 3.151L18.7 10.498A6.955 6.955 0 0 0 7.049 9.17l6.917-1.932a.75.75 0 1 1 .403 1.445zm2.746 6.823 10.558-2.956a7 7 0 0 0-.062-2.984L5.825 15.656a6.954 6.954 0 0 0 12.866.962l-9.572 2.68a.75.75 0 1 1-.404-1.445"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChristmas;
